<template>
  <Accordion
      :trigger-class="`faq__trigger`"
      :trigger-active-class="`faq__trigger--active`"
      :panel-class="`faq__panel`"
      :panel-active-class="`faq__panel--active`"
      :title="title"
      class="faq__accordion"
  >
    <template slot="trigger" class="d-flex justify-content-between">
      <h3 class="faq__title">{{ title }}</h3>
      <Plus class="faq__icon" />
    </template>
    <template slot="content">
      <div class="faq__body" v-html="body" />
    </template>
  </Accordion>
</template>

<script>
import Plus from '~/assets/icons/plus.svg?inline';

export default {
  components: {
    Plus,
  },
  props: {
    title: { type: String, required: true },
    body: { type: String, required: true },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/components/_faq.scss';
</style>
